import React from 'react';
import { Button, Callout, Container, Text, Title, Flex } from '@homeexchange/design';
import i18n from '../../../i18n';
import { getRedirectTo } from '../../../utils/verificationRedirect';
var UserPendingVerification = function () {
    var redirectTo = getRedirectTo();
    return (React.createElement(Container, { className: "container", isFluid: true },
        React.createElement(Flex, { className: "verification-content", direction: "column" },
            React.createElement(Title, { level: 2 }, i18n.t('user:how_does')),
            React.createElement(Callout, { status: "info", hasIcon: true },
                React.createElement(Text, null, i18n.t('user:page_verification_pending_callout'))),
            React.createElement(Text, { size: "lg", isBold: true }, i18n.t('user:page_verification_pending_subheader')),
            React.createElement(Text, null, i18n.t('user:page_verification_pending_getback')),
            React.createElement(Text, { dangerouslySetInnerHTML: {
                    __html: i18n.t('user:page_verification_pending_contact', {
                        url: i18n.t('url:contact_us_he')
                    })
                } }),
            React.createElement(Button, { onClick: function () { return window.location.assign(redirectTo !== null && redirectTo !== void 0 ? redirectTo : i18n.t('url:dashboard')); } }, i18n.t(redirectTo ? 'common:back' : 'user:global_returnDashboard')))));
};
export default UserPendingVerification;
